import React from 'react';
import PropTypes from 'prop-types';
import tpl from '../templates/main';
import {View} from 'MWC';
import {canUseDOM} from './../../../../../helpers/canUseDOM';
import {apiback} from '../../../../../config';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            tab: 'what-is',
            verticalTab: 'creating-consent',
            isSegmentedCollapsed: canUseDOM ? window.innerWidth <= 1200 : false,
            isAccessibilityTableMobile: canUseDOM ? window.innerWidth <= 960 : false,
            accessibilityStatisticsLoader: true,
            accessibilityStatisticsData: null,
            accessibilityStatisticsError: null
        };
        return this;
    }

    updateWidth = () => {
        this.setState({
            isSegmentedCollapsed: window.innerWidth <= 1200,
            isAccessibilityTableMobile: window.innerWidth <= 960
        });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateWidth);
        this.getAccessibilityStatisticsData();
    }

    getAccessibilityStatisticsData = async () => {
        try {
            const url = apiback('API_OPENBANKING_ACCESSIBILITY_STATISTICS');

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Accept: 'application/json'
                },
                body: JSON.stringify({
                    year: new Date().getFullYear()
                })
            });

            const json = await response.json();

            if (response.status === 502) {
                this.setState({
                    accessibilityStatisticsError:
                        json.message || this.l10n('OPEN_BANKING_ACCOUNT_STATISTICS_ERROR')
                });
                return;
            }

            if (!response.ok) {
                this.setState({
                    accessibilityStatisticsError: this.l10n('OPEN_BANKING_ACCOUNT_STATISTICS_ERROR')
                });
                return;
            }

            this.setState({
                accessibilityStatisticsData: json.stats || [],
                accessibilityStatisticsError: null
            });
        } catch (e) {
            this.setState({
                accessibilityStatisticsError: this.l10n('OPEN_BANKING_ACCOUNT_STATISTICS_ERROR')
            });
        } finally {
            this.setState({
                accessibilityStatisticsLoader: false
            });
        }
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    }

    toggleTab = tab => {
        this.setState({tab: tab});
    };

    toggleVerticalTab = verticalTab => {
        this.setState({verticalTab: verticalTab});
    };

    navigate = (...args) => {
        return this.context.app.navigate(...args);
    };

    static displayName = 'OpenBanking.Main';

    static contextTypes = {
        app: PropTypes.object
    };
}
